import React from 'react'
import styles from '../components/componentsStyles/About.module.css';
import { Link } from 'react-router-dom';
import AboutIntro from '../components/aboutComponents/AboutIntro';
import NewCardsComponent from '../components/aboutComponents/NewCardsComponent';
import NewCardsComponent2 from '../components/aboutComponents/NewCardsComponent2';

const About = () => {
  
  return (
      
    <div className={styles.aboutPage}>
        
      <div className={styles.aboutIntro}>
        <AboutIntro/>
      </div>

      <div className={styles.actions}>
        <button >
            Scroll down to see more
        </button>   
      </div>


      
        <div style={{textAlign: 'center'}}>
          <h2 style={{fontSize: '2.5em', fontWeight: 'bolder'}}> Technical skills</h2>
          <p>Please hover a card to select and click to reveal information about-it</p>
        </div>



      <div className={styles.aboutCards}>
        <div className={styles.newCards}>
          <h2 style={{ textAlign: 'center', fontSize: '2.5em', fontWeight: 'bolder'}}> T3 Stack </h2>
          <NewCardsComponent/>
        
        </div>
        
        <div className={styles.newCards2}>
          <h2 style={{ textAlign: 'center', fontSize: '2.5em', fontWeight: 'bolder'}}> MERN Stack </h2>
          <NewCardsComponent2/>
        </div>
      </div>

      <div className={styles.projectsLink}>
  
          <Link to='/docs/stacks' className='light-link'> 
          Read more about the technologies i use! 
          </Link>

          <Link to='/projects' className='light-link'> 
          Se some of my projects! 
          </Link>
       
      </div>
        
    </div>
    
  )
}

export default About